import React from 'react'

const React_Assignment_5 = () => {
  return (
    <div>
      <h1>Assignment 5</h1>
    </div>
  )
}

export default React_Assignment_5
